import { useState } from "react";
import ExpandCollapse from "./ExpandCollapse";

## Basic Usage

export function BasicExpandCollapse() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <ExpandCollapse expanded={expanded} onClick={() => setExpanded(!expanded)} />
      <span>{expanded ? "Expanded" : "Collapsed"}</span>
    </div>
  );
}

<BasicExpandCollapse />

---

## Toggle States

<div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <ExpandCollapse expanded={false} onClick={() => {}} />
    <span>Collapsed</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <ExpandCollapse expanded onClick={() => {}} />
    <span>Expanded</span>
  </div>
</div>

---

## Custom Sizes

<div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <ExpandCollapse expanded={false} onClick={() => {}} size={10} />
    <span>10px</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <ExpandCollapse expanded={false} onClick={() => {}} size={14} />
    <span>14px (default)</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <ExpandCollapse expanded={false} onClick={() => {}} size={20} />
    <span>20px</span>
  </div>
</div>

---

## With Content

export function WithContent() {
  const [expanded, setExpanded] = useState(true);
  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}
        onClick={() => setExpanded(!expanded)}
      >
        <ExpandCollapse expanded={expanded} onClick={() => {}} />
        <span style={{ fontWeight: 500 }}>Section Title</span>
      </div>
      {expanded && (
        <div style={{ marginLeft: "1.5rem", marginTop: "0.5rem", padding: "0.5rem", background: "#f5f5f5", borderRadius: "4px" }}>
          This content is visible when expanded.
        </div>
      )}
    </div>
  );
}

<WithContent />

---

## Tree Navigation Example

export function TreeExample() {
  const [folders, setFolders] = useState({ src: true, components: false, utils: false });
  const toggle = (key) => setFolders((prev) => ({ ...prev, [key]: !prev[key] }));
  return (
    <div style={{ fontFamily: "monospace", fontSize: "14px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.25rem", cursor: "pointer" }} onClick={() => toggle("src")}>
        <ExpandCollapse expanded={folders.src} onClick={() => {}} size={12} />
        <span>src/</span>
      </div>
      {folders.src && (
        <div style={{ marginLeft: "1rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.25rem", cursor: "pointer" }} onClick={() => toggle("components")}>
            <ExpandCollapse expanded={folders.components} onClick={() => {}} size={12} />
            <span>components/</span>
          </div>
          {folders.components && (
            <div style={{ marginLeft: "1.25rem", color: "#666" }}>
              <div>Button.tsx</div>
              <div>Modal.tsx</div>
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "0.25rem", cursor: "pointer" }} onClick={() => toggle("utils")}>
            <ExpandCollapse expanded={folders.utils} onClick={() => {}} size={12} />
            <span>utils/</span>
          </div>
          {folders.utils && (
            <div style={{ marginLeft: "1.25rem", color: "#666" }}>
              <div>helpers.ts</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

<TreeExample />


